import { whitelabelConfig } from '@/lib/constants/whitelabelConfig'
import { Action, Subject } from '@/lib/permissions'
import { forwardRef } from '@eigtech/ui-shared-dave'
import {
  MobileNavigation as BaseMobileNavigation,
  Navigation as BaseNavigation,
  NavButton,
  NavigationProps,
  navButtonStyleProps,
} from '@eigtech/ui-shared-navigation'
import { memo, useMemo } from 'react'
import { MdBugReport, MdInfo } from 'react-icons/md'
import { ROUTER_PATHS } from '../../../lib/constants'
import { ApplicationMenu } from '../ApplicationMenu'
import { UserMenu } from '../UserMenu'
import { NavId, useNavs } from './navs'
import { useNavCollapsedSetting } from './useNavCollapsedSetting'

function useNavProps() {
  const navCollapsedSettings = useNavCollapsedSetting()

  const navs = useNavs()

  return useMemo<NavigationProps<Action, Subject, NavId>>(
    () => ({
      ...navCollapsedSettings,
      heading: whitelabelConfig.title,
      headingProps: { fontSize: 'lg' },
      navs,
      bottomNavItems: [
        <NavButton
          key="documentation"
          item={{
            icon: MdInfo,
            label: 'Documentation',
            navId: '',
            url: { to: ROUTER_PATHS.documentation.route },
          }}
        />,
        ({ isCollapsed }) => (
          <ApplicationMenu
            key="applicationMenu"
            {...navButtonStyleProps}
            isCollapsed={isCollapsed}
          />
        ),
        <NavButton
          key="jiraForm"
          item={{
            icon: MdBugReport,
            label: 'Submit Bug',
            href: 'https://eigtechnology.atlassian.net/jira/software/form/cd1a1b01-5e79-4f99-b225-e16e39617bc1?atlOrigin=eyJpIjoiODNiZTc3MmEwNjQ0NDMzZDg4OGQwNDhhZGI3YzQwZmUiLCJwIjoiaiJ9',
            target: 'jiraForm',
          }}
        />,
        ({ isCollapsed }) => (
          <UserMenu key="userMenu" {...navButtonStyleProps} isCollapsed={isCollapsed} />
        ),
      ],
    }),
    [navCollapsedSettings, navs]
  )
}

export const Navigation = memo(
  forwardRef<Partial<NavigationProps<Action, Subject, NavId>>, 'div'>((props, ref) => {
    const defaults = useNavProps()

    return <BaseNavigation ref={ref} id="main-navigation" {...defaults} {...props} />
  })
)

export function MobileNavigation() {
  const defaults = useNavProps()
  return <BaseMobileNavigation {...defaults} />
}
